import { Backdrop, Box, CircularProgress, Divider, Drawer, Typography, useTheme } from "@mui/material";
import React from "react";
import { CustomTypography } from "../formsComponents";
import { IRightPanelProps } from "./interfaces/IRightPanelProps";
import { Close } from "@mui/icons-material";

export const RightPanel: React.FC<IRightPanelProps> = (props) => {
  const {
    open,
    heading,
    headerRightContent,
    isWrappedWithForm = false,
    onFormSubmit,
    showBackdrop,
    subHeading,
    actionButtons,
    width,
    onClose,
    hideScroll = false,
    drawerProps,
    paperSx,
  } = props;

  const theme = useTheme();

  const content = () => {
    return (
      <Box
        display="flex"
        flexDirection={"column"}
        justifyContent="space-between"
        height={"100%"}
        onClick={(e) => e.stopPropagation()}
      >
        <Box flex={1}>
          <Box
            display={'flex'}
            justifyContent={'space-between'}
            alignItems={'center'}
            mb={2}
            sx={{
              padding: "6px 5px",
              backgroundColor: theme.palette.primary.main,
            }}
          >
            <Typography variant="h2" fontWeight={"bold"} color="#fff">
              {heading}
            </Typography>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              {headerRightContent}
              <Box sx={{ cursor: "pointer" }} onClick={onClose}>
                <Close sx={{ color: '#fff' }} />
              </Box>
            </Box>
          </Box>
        </Box>
        {/* {subHeading && (
          <CustomTypography variant="body1">{subHeading}</CustomTypography>
        )} */}
        <Box
          flex={10}
          sx={{
            overflowY: hideScroll ? "hidden" : "auto",
            padding: "0px 5px",
            pr: hideScroll ? "0px" : "5px",
          }}
        >
          {props.children}
        </Box>
        {actionButtons && (
          <Box flex={1} sx={{ padding: "0px 5px", }}>
            <Divider sx={{ marginBottom: 3 }} />
            {actionButtons()}
          </Box>
        )}
      </Box>
    );
  };
  const wrappedWithForm = () => {
    if (isWrappedWithForm && onFormSubmit) {
      return (
        <form onSubmit={onFormSubmit} style={{ height: "100%" }}>
          {content()}
        </form>
      );
    }
    return content();
  };

  return (
    <Drawer
      anchor="right"
      open={open}
      sx={drawerProps}
      PaperProps={{
        sx: {
          width: {
            xs: "100%",
            md: "80%",
            lg: width || "35%",
          },
          padding: "10px 0px",
          paddingTop: 0,

          height: "100vh",
          ...paperSx,
        },
      }}
      onClose={onClose}
    >
      {wrappedWithForm()}

      {showBackdrop && (
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={showBackdrop}
        >
          <CircularProgress size={100} />
        </Backdrop>
      )}
    </Drawer>
  );
};
